export default {
  SET_ERROR(state, data) {
    state.error = data
  },

  SET_LOADING(state, data) {
    state.loading = data
  },

  GET_ALL_TAX_ADMIN(state, data) {
    state.items = data.items
    state.pagination.total = data.total_pages
    state.pagination.page = data.current_page
  },

  GET_LIST_COUNTRIES(state, data) {
    state.countryOptions = data
  },

  GET_LIST_STATE(state, data) {
    state.provinceStateOptions = data
  },

  UPDATE_LIST_STATE(state, data) {
    state.provinceStateOptions.push(data)
  }
}
